import React, { Component } from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getServicesBySalonId } from "../../store/modules/getServicesBySalonId";
import { getTimeslots } from "../../store/modules/getTimeslots";
import { createBooking } from "../../store/modules/createBooking/index";
import { colors } from "../../resources/ThemeColors";
import { breakpoints } from "../../Media";
import BookingsInput from "./BookingsInput";
import Loader from "../../components/Loader/Loader";
import renderIf from "render-if";

const MainDiv = styled.div`
  height: 80vh;
  background-color: ${colors.main};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContentCard = styled.div`
  height: 70%;
  width: 50%;
  border: 1px;
  position: absolute;
  background-color: white;
  border-radius: 18px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
  margin-top: 2em;

  @media (max-width: ${breakpoints.mobileMin}) {
    width: 90%;
    height: auto;
    margin: auto;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    width: 75%;
    margin: auto;
  }
`;

const TitleDiv = styled.div`
  height: 20%;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BookingsTitle = styled.h3`
  font-size: 1.2em;
  font-weight: 750;
  width: auto;
  color: #4c4f4e;
  text-align: center;

  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 1.1em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    font-size: 1.2em;
  }
`;

const Error = styled.p`
  color: red;
  font-weight: 450;
  font-size: 0.8em;
`;

var today = new Date();
var dd = String(today.getDate()).padStart(2, "0");
var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
var yyyy = today.getFullYear();
today = yyyy + "-" + mm + "-" + dd;
var date = today.toString();

class Bookings extends Component {
  state = {
    salonName: "",
    salon: "",
    timeslot: "",
    date: date,
    service: null,
    error: null,
    timeslots: [],
  };

  componentDidMount() {
    this.setState({
      salon: this.props.match.params.id,
      salonName: this.props.match.params.name,
    });
    // localStorage.setItem("selectedDate", date);
    // localStorage.setItem("salonId", this.props.match.params.id);
    this.requestServices(this.props.match.params.id);
  }

  requestServices = (id) => {
    const { getServicesBySalonId } = this.props;
    getServicesBySalonId(id);
  };

  handleChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (
      this.state.service === null ||
      this.state.timeslot === "" ||
      this.state.date === ""
    ) {
      this.setState({ error: "error" });
    } else {
      this.handleCreateBooking();
    }
  };

  handleCreateBooking = () => {
    const { createBooking } = this.props;
    const bookingData = {
      start_time: this.state.timeslot,
      service: this.state.service,
      salon: this.state.salon,
      date: this.state.date,
    };
    createBooking(bookingData);
  };

  goBack = (e) => {
    e.preventDefault();
    this.props.history.goBack();
  };

  randomValue = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };
  render() {
    const { servicesRequestInBookings } = this.props;
    const { services, message } = servicesRequestInBookings;
    return (
      <>
        {renderIf(message === "fetching")(
          <MainDiv>
            <Loader />
          </MainDiv>
        )}
        {renderIf(message === "failure")(
          <MainDiv>
            <p>Something went wrong, try again later.</p>
          </MainDiv>
        )}

        {renderIf(message === "success")(
          <MainDiv>
            <ContentCard>
              <TitleDiv>
                <BookingsTitle>
                  Create an Appointment in {this.state.salonName}
                </BookingsTitle>
              </TitleDiv>
              {renderIf(this.state.error !== null)(
                <Error>Please fill all the fields</Error>
              )}
              <BookingsInput
                handleChange={this.handleChange}
                service={this.state.service}
                timeslot={this.state.timeslot}
                services={services}
                handleSubmit={this.handleSubmit}
                newDate={this.state.date}
                salonId={this.props.match.params.id}
                start_time={this.state.start_time}
                message={message}
                goBack={this.goBack}
                randomValue={this.randomValue}
              />
            </ContentCard>
          </MainDiv>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  servicesRequestInBookings: state.singleServiceReducer,
  createBookingRequest: state.createBookingReducer,
  timeslotsRequest: state.timeslotsReducer,
});

export const mapDispatchToProps = (dispatch) => ({
  getServicesBySalonId: (id) => dispatch(getServicesBySalonId(id)),
  createBooking: (bookingData) => dispatch(createBooking(bookingData)),
  getTimeslots: (timeslotData) => dispatch(getTimeslots(timeslotData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Bookings));
